import React from 'react'
import { Auth } from '../Auth'

export const AuthLayout: React.FC = () => {
  return (
    <Auth />
  )
}
